import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { getOutletAddons } from '@/renderer/services/menuService';

export function useAddons(outletId?: string | null) {
  return useQuery({
    queryKey: queryKeys.menu.addons(outletId),
    queryFn: async () => {
      const res = await getOutletAddons(outletId);
      if (!res.success) throw new Error(res.error ?? 'Failed to fetch addons');
      return res.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
}
